export const isAuthenticated = state => {
    console.log(localStorage.getItem('accessToken'))
    return localStorage.getItem('accessToken') !== null

}

export const getUserauthResponse = state => {
    return state.authResponse
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js